import React, { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "./style.css";
import CannedResponse from "../../../components/dashboardcomponents/ProfileComponents/CannedResponse";
import TagsManagement from "../../../components/dashboardcomponents/ProfileComponents/TagsManagement";
import GroupSelectDropdown from "../../../components/dashboardcomponents/ProfileComponents/GroupSelectDropdown";
import Security from "../../../components/dashboardcomponents/Settings/Security";
import EmailBranding from "../../../components/dashboardcomponents/Settings/EmailBranding";
import CustomBusinessDomain from "../../../components/dashboardcomponents/Settings/CustomBusinessDomain";
import BusinessTicketConfirmationEmail from "../../../components/dashboardcomponents/Settings/BusinessTicketConfirmationEmail";
import EditProfileMain from "../../../components/dashboardcomponents/TeamComponents/TeamEditProfile/EditProfileMain";
import SessionsManagement from "../../../components/dashboardcomponents/ProfileComponents/SessionsManagement";
import { isHeaderInlinePageTitleEnabled } from "../../../config/featureFlags";

function TicketManagment() {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [isKnowledgeBaseTabActive, setIsKnowledgeBaseTabActive] =
    useState(false);
  const userData = useSelector((state) => state.loginToken);
  const coUserData = useSelector((state) => state.loginTokenCoUser);

  const uID = userData.response?.user?._id || coUserData?.response?.user?._id;
  const roleName =
    userData?.response?.user?.role_name || coUserData?.response?.user?.role_name;
  const isAdminWithBilling = roleName === "admin_with_billing";

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  const profileTabs = useMemo(() => {
    const list = [
      { key: "profile", label: t.PROFILEINFORMATION },
      { key: "security", label: "Password & Security" },
      { key: "tags", label: "Tags Management" },
      { key: "canned", label: t.CANNEDRESPONSE },
      { key: "sessions", label: "Sessions" },
    ];
    if (isAdminWithBilling) {
      list.push(
        { key: "customDomain", label: "Custom Domain" },
        { key: "businessTicketEmail", label: "Business Ticket Confirmation" },
      );
    }
    list.push({ key: "emailBranding", label: "My Ticket Email" });
    return list;
  }, [t, isAdminWithBilling]);

  useEffect(() => {
    if (activeTabIndex >= profileTabs.length) {
      setActiveTabIndex(0);
    }
  }, [profileTabs.length, activeTabIndex]);

  const activeKey = profileTabs[activeTabIndex]?.key ?? "profile";

  const registrationUIRender = useMemo(() => {
    switch (activeKey) {
      case "profile":
        return (
          <EditProfileMain userId={uID} showProfileComponent={false} />
        );
      case "security":
        return <Security />;
      case "tags":
        return (
          <TagsManagement
            selectedGroupId={selectedGroupId}
            onKbTabChange={setIsKnowledgeBaseTabActive}
          />
        );
      case "canned":
        return <CannedResponse />;
      case "sessions":
        return <SessionsManagement />;
      case "customDomain":
        return <CustomBusinessDomain />;
      case "businessTicketEmail":
        return <BusinessTicketConfirmationEmail />;
      case "emailBranding":
        return <EmailBranding />;
      default:
        return null;
    }
  }, [activeKey, uID, selectedGroupId]);

  const showGroupDropdown = activeKey === "tags" && !isKnowledgeBaseTabActive;

  return (
    <div style={{ marginTop: "0px" }}>
      <div className="TicketManagment-Container001">
        <div
          className="profile-header-row"
          style={
            isHeaderInlinePageTitleEnabled
              ? { justifyContent: "flex-end" }
              : undefined
          }
        >
          {/* Legacy in-page title — hidden when header shows inline title (Application V2) */}
          {!isHeaderInlinePageTitleEnabled && (
            <p className="Ticket-text">{t.PROFILEMANAGEMENT}</p>
          )}
          {showGroupDropdown ? (
            <GroupSelectDropdown
              onSelect={setSelectedGroupId}
              value={selectedGroupId}
            />
          ) : (
            <div style={{ height: "40px" }} />
          )}
        </div>
        <div className="Ticket-main-header" style={{ marginTop: "23px" }}>
          <div className="Ticket-text-section">
            {profileTabs.map((tab, index) => (
              <p
                key={tab.key}
                className={`ticket-header-text ${
                  activeTabIndex === index ? "TicketHeaderActive" : ""
                }`}
                onClick={() => {
                  setActiveTabIndex(index);
                  setIsKnowledgeBaseTabActive(false);
                }}
              >
                {tab.label}
              </p>
            ))}
          </div>
        </div>
      </div>

      <div className="Team-Main-Container">{registrationUIRender}</div>
    </div>
  );
}

export default TicketManagment;
